import { ActionTypes } from "../constants";
import LOCAL_STORAGE from "../localStorage";

export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const clearDemoData = () => {
	const oldState = LOCAL_STORAGE.loadState() || {};
	delete oldState["demoData"];

	return (dispatch) => {
		return new Promise((resolve) => {
			LOCAL_STORAGE.saveState({
				...(oldState || {}),
			});

			dispatch(logoutUser());
			resolve("success");
		});
	};
};

export const receiveLogout = () => {
	return {
		type: LOGOUT_SUCCESS,
		isFetching: false,
		isAuthenticated: false,
	};
};

export const logoutUser = () => {
	const oldState = LOCAL_STORAGE.loadState() || {};

	// Clear all data except demo config file
	Object.keys(oldState).forEach((key) => {
		if (key !== "demoData" && key !== "useMocks") {
			delete oldState[key];
		}
	});

	return (dispatch) => {
		return new Promise((resolve) => {
			LOCAL_STORAGE.saveState({
				...(oldState || {}),
			});

			dispatch(receiveLogout());
			resolve("success");
		});
	};
};

// ------------------------------------- USED -------------------------------------
export const loginUser = (creds = {}) => {
	return (dispatch) => {
		let account = {
			publicKey: creds?.pub,
		};

		// TODO: do we need this?
		//localStorage.setItem("account", JSON.stringify(account));

		dispatch({
			type: ActionTypes.LOGIN_SUCCESS,
			user: account,
		});
	};
};

export const setUserKeys = (data = { publicKey: "", privateKey: "" }) => {
	//loginUser(data);

	let oldState = LOCAL_STORAGE.loadState() || {};
	LOCAL_STORAGE.saveState({
		...oldState,
		...data,
	});

	return (dispatch) => {
		return new Promise((resolve) => {
			dispatch({
				type: ActionTypes.SET_USER_KEYS,
				data: {
					...data,
					isProducer: data.isProducer,
					isAuthenticated: true,
					account: {
						publicKey: data.pub,
					},
				},
			});

			resolve("success");
		});
	};
};

export const setUserNickname = (nickname) => {
	let newState = LOCAL_STORAGE.loadState() || {};

	LOCAL_STORAGE.saveState({ ...newState, nickname });

	return (dispatch) => {
		return new Promise((resolve) => {
			/* dispatch({
				type: ActionTypes.SET_USER_KEYS,
				data: newState,
			});
 */
			resolve("success");
		});
	};
};
